import $ from 'jquery';
import LANG from '../lang/prop_en.js';
import { occoApi } from './occoAPI-module.js';

export const ST_TEXTS = {
  noImages:
    'Oops, looks like you have no images in your album yet.<br> <br>Learn how to link images and videos with your album. ',
  noImagesWithoutLink: 'Oops, looks like you have no images in your album yet.',
  noImagesSelfies:
    'Oops, looks like you have not registered your selfie to unlock your Photo+ images and videos that will appear here. Take a selfie now or scan QR to receive your priceless memories.',
  myTickets: 'My Photo+',
  noImagesSelfiesWA:
    'Oops, looks like you have not yet registered faces we can use to find your images. Please register one good selfie for each member of your party.',
  myWebApp: 'My Album',
  paidMessage:
    'Oops, looks like you do not have a Photo+ Pass yet.<br><br>Get yours now to gain access to high resolution content. ',
  addPhotoPlusMessage:
    'Would you like to add a<br>Photo+ to your shopping<br>cart and gain access to<br>all your digitals?',
  digitalUnlockDupMessage:
    'You already have a digital access package in your shopping cart.<br>A new package can not be added until you remove or purchase the current one.',
  scanQR: 'Scan the QR code on images or videos of you from the photo viewing kiosk to link your media with this app.',
  helpQR: 'Where can I find the QR of my photo?',
  videoAccess: '🎥 Please ensure that you have enabled the camera access to scan QR code.',
  showMyQR:
    'Scan this QR code to our Photo+ photographer to use it to access your photos at any photo sales locations.',
  showMyQRWA: 'Scan this QR at the kiosk to access your photos, or present it to our roaming photographers when asked.',
  opTutorial: 'FAQs',
  regFace: 'Register a face',
  scanLinkQR: 'Link my photo',
  showMyQRBut: 'Show my Photo ',
  showMyQRButWA: 'Show my QR',
  faceRegTitle: 'Your images and videos will appear here <br>once you have registered your face. ',
  rightFaceMessage:
    'Please make sure that your face is evenly illuminated and fully visible. Maintain neutral expression.',
  noFaceMask: 'NO FACE MASKS',
  shareDownloadRestrict: 'You can share or download only one picture at a time.',
  downloadRestrict: 'You can download only one picture at a time.',
  emptyCart: 'Cart is empty',
  addAnotherProd: 'Add another product',
  addAnotherProdWA: 'Choose an add-on',
  shippingMessage: 'Shipping and discount codes are added at checkout.',
  noVisitDateMessage:
    'Oops, looks like you don’t have a valid ticket yet for your park visit. Link your ticket to enjoy our Photo+ experience.',
  scannedImage: 'Yay, great picture! For Security please confirm. Is this your image?',
  selfieAlbDefTxt: 'Add a selfie or a portrait picture<br> for each member of your party.',
  selfieEmptyTxt: 'There are no recent images in this album.',
  notAvailableYet: "Your Photo+ experience is available during your Genting SkyWorlds' visit.",
  noUidMessage: 'Oops, there was an issue locating your account. Please try again.',
  noSelfiesSugMessage:
    'Oops, looks like you have not registered your selfie. Take a selfie now to receive your priceless memories.',
  shootPhoto: "Look at the camera and click 'Shoot' when ready",
  countDownPhoto: 'Look at the lights',
  renderingVideo: 'Your content is being created. Check your album in a few seconds for an awesome new video!',
  uploadUGCTxt: 'Upload a photo from your camera roll for printing!',
  asyncUGCUploadText: 'Your photos will be in your album in a minute!',
  deleteRestrictHelp:
    'You must keep at least one package in your shopping cart if you wish to purchase add-ons. If you need to change the package - please first remove all add-ons from your shopping cart.',
};

// After doing any changes please keep sync this duplicate files in GENTING_APP_HTML and PHOTOALBUM projects
export const REAL_IMAGE_PATH = process.env.IMG_PATH;
export const OCCO_360_VIEWER_PATH = `${REAL_IMAGE_PATH}/360viewer/`;

export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatCurrency(currencyCode) {
  if (currencyCode === 'USD') return '$';
  return currencyCode;
}

function formatDecimals(value, digitals = 2) {
  return (Math.round(value * 100) / 100).toFixed(digitals);
}

export function formatPrice({ amount = 0, currencyCode = 'USD' }) {
  return `${formatCurrency(currencyCode)}${formatDecimals(amount)}`;
}

export function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return decodeURI(pair[1]);
    }
  }
  return false;
}

export function showLoading() {
  $('.screenOverlay').show();
  $('#cssload-cupcake').show();
}

export function hideLoading() {
  setTimeout(() => {
    $('#cssload-cupcake').hide();
    $('.screenOverlay').hide();
  }, 100);
}

export function alertMessagePopup(text) {
  const opt = {
    title: LANG.occo_album,
    body: text,
  };
  elId('messagePopUpTitle').innerHTML = opt.title ? opt.title : '';
  elId('messagePopUpBody').innerHTML = opt.body ? opt.body : '';
  $('#messagePopUp').modal('show');
}

export function getEventName() {
  return localStorage.getItem('eventName');
}

export function elId(id) {
  return document.getElementById(id);
}

export function get360url(normalImageUrl) {
  return `${OCCO_360_VIEWER_PATH}?url=${normalImageUrl}&closeable=false`;
}

export function trackPhotoEvent(activityName, photoId, robotId) {
  const activityType = 'info';
  const attUid = localStorage.getItem('attUidWA') || getQueryVariable('uId');
  occoApi.activityCreateByRobotId(robotId, photoId, activityName, activityType, attUid, (err) => {
    if (err) {
      return alertMessagePopup(err.message_key);
    }
  });
}

export function trackListOfPhotoEvent(activityName, listOfPhotoId, robotId) {
  const attUid = localStorage.getItem('attUidWA') || getQueryVariable('uId');
  const activityType = 'info';
  occoApi.activityBulkCreateByRobotId(robotId, listOfPhotoId, activityName, activityType, attUid, (err) => {
    if (err) {
      return alertMessagePopup(err.message_key);
    }
  });
}

export function isAndroid() {
  return navigator.userAgent.match(/android/i);
}

export function isIPhone() {
  return navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)/i);
}

export function isMobile() {
  return isAndroid() || isIPhone();
}
